(function () {
    //Format CNIC Number
    angular.module('tmx-app').filter('cnic', function () {
        return function (value, format) {
            if (!value) return '';
            var nVal = value.trim().replace(/-/g, '');
            if (!format) {
                format = '#####-#######-#';
            }
            if (nVal.length != (format.match(/#/g) || []).length) return value;

            var res = format;
            for (var i = 0; i < nVal.length; i++) {
                res = res.replace('#',nVal[i]);
            }
            return res;
        };
    });
})();